// extracted by mini-css-extract-plugin
export var boxItems = "_b9-1";
export var boxItemsLg = "_b9-2";
export var button = "_b9-7";
export var buttonHoverless = "_b9-9";
export var buttonLg = "_b9-8";
export var filterGroupBox = "_b9-0";
export var icon = "_b9-3";
export var iconSecondary = "_b9-6";
export var iconWrapper = "_b9-4";
export var iconWrapperLg = "_b9-5";
export var truncatedLabel = "_b9-a";